import { DocumentData } from "@angular/fire/firestore";
import { StringTimeframe } from "./string-timeframe.model";
import * as moment from "moment-timezone";

export class StringTimeframeBuilder {
  private _begin: string;
  private _end: string;

  constructor(public readonly timezone) {
    this.default();
  }

  default(): void {
    this._begin = moment.tz(this.timezone).format("MM/DD/YYYY");
    this._end = null;
  }

  load(data: DocumentData): StringTimeframeBuilder {
    this._begin = data.begin;
    this._end = data.end;
    return this;
  }
  edit(data: StringTimeframe): StringTimeframeBuilder {
    this._begin = data.begin;
    this._end = data.end;
    return this;
  }

  //<!-- ----------------------------------------------------------------------- -->
  //<!--                            GETTERS/SETTERS                              -->
  //<!-- ----------------------------------------------------------------------- -->
  public get hasEnd(): boolean {
    return this._end != null;
  }

  public get begin(): string {
    return this._begin;
  }

  public set begin(s: string) {
    this._begin = s;
  }

  public get end(): string {
    return this._end;
  }

  public set end(s: string) {
    this._end = s;
  }

  public toJSON = () => ({ begin: this._begin, end: this._end });
  public toString = (): string =>
    this.begin + (this.end ? " - " + this.end : "");
}
